// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/not-at-all-gradient.svg';

export const NotAtAllGradient = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
